import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const IMAGES = {
    doctor: "/assets/portrait.jpeg",
    hospital: "https://images.unsplash.com/photo-1574958269340-fa927503f3dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxob3NwaXRhbCUyMGJ1aWxkaW5nJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzg3MzMzNTA3fDA&ixlib=rb-4.1.0&q=85",
    education: "https://images.pexels.com/photos/8533045/pexels-photo-8533045.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CLINIC = {
    doctorName: "Dr. Krishnakanth AVB",
    hospital: "Preethi Multispeciality Hospital",
    address: "50, Melur Main Road, Uthangudi, Madurai, Tamil Nadu 625107",
    phoneDisplay: "+91 93605 10074",
    phoneHref: "tel:+919360510074",
    email: "krishnakanth002@gmail.com",
    whatsapp: "https://wa.me/919360510074",
    instagram: "https://www.instagram.com/uro_bytes",
    opd: "Monday – Saturday · 10:00 AM – 5:00 PM",
    opdSchedule: [
        { day: "Monday", hours: "10:00 AM – 5:00 PM" },
        { day: "Tuesday", hours: "10:00 AM – 5:00 PM" },
        { day: "Wednesday", hours: "10:00 AM – 5:00 PM" },
        { day: "Thursday", hours: "10:00 AM – 5:00 PM" },
        { day: "Friday", hours: "10:00 AM – 5:00 PM" },
        { day: "Saturday", hours: "10:00 AM – 5:00 PM" },
        { day: "Sunday", hours: "OPD Closed" },
    ],
    emergency: "24×7 emergency consultation available",
    mapsEmbed: "https://maps.google.com/maps?q=Preethi%20Multispeciality%20Hospital%2C%2050%20Melur%20Main%20Rd%2C%20Uthangudi%2C%20Madurai%2C%20Tamil%20Nadu%20625107&t=&z=15&ie=UTF8&iwloc=&output=embed",
    mapsLink: "https://www.google.com/maps/search/?api=1&query=Preethi+Multispeciality+Hospital%2C+50+Melur+Main+Rd%2C+Uthangudi%2C+Madurai%2C+Tamil+Nadu+625107",
};

// Instagram reel/post shortcodes to feature on the homepage, e.g. ["C8abcXYZ123", "C9defXYZ456"]
// Find the code in the reel URL: instagram.com/reel/<CODE>/
export const INSTAGRAM_REELS = ["DcvrSLsz1bf", "DdBtIgwz_lJ", "DdWHIDLzmjf", "DdYUlhwzV9z", "Ddd06umzr_n", "DbWErzoi9_e", "DcbxVW8z04Q", "Dcs5tBnz-EH"];

const px = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=940`;

export const GOOGLE_REVIEW_URL = "https://g.page/r/CUzMlgJ3bg_GEBI/review";

// Real Google reviews — added only after they exist on the Google Business Profile.
// Each: { name, text, rating (1-5), date }
export const GOOGLE_REVIEWS = [];

export const CATEGORY_MEDIA = {
    "Kidney & Urinary Tract": { img: px(7108420), alt: "Doctor performing an ultrasound scan", bar: "bg-sky-500", chip: "bg-sky-50 text-sky-700 border-sky-200" },
    "Prostate": { img: px(8376196), alt: "Doctor explaining a scan to a patient", bar: "bg-indigo-500", chip: "bg-indigo-50 text-indigo-700 border-indigo-200" },
    "Male Urology": { img: px(5336957), alt: "Two men in a consultation discussion", bar: "bg-teal-500", chip: "bg-teal-50 text-teal-700 border-teal-200" },
    "Urethra & Reconstructive": { img: px(24193881), alt: "Modern operating room", bar: "bg-cyan-600", chip: "bg-cyan-50 text-cyan-700 border-cyan-200" },
    "Urethra & Reconstructive Urology": { img: px(24193881), alt: "Modern operating room", bar: "bg-cyan-600", chip: "bg-cyan-50 text-cyan-700 border-cyan-200" },
    "Urological Oncology": { img: px(8016910), alt: "Kidney cancer awareness lettering", bar: "bg-blue-700", chip: "bg-blue-50 text-blue-800 border-blue-200" },
    "Pediatric Urology": { img: px(8612924), alt: "Child playing outdoors", bar: "bg-emerald-500", chip: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const TREATMENT_MEDIA = {
    "Stone Surgery": { img: px(7088491), alt: "Doctor performing an ultrasound examination", bar: "bg-sky-500" },
    "Prostate Procedures": { img: px(8376225), alt: "Doctor reviewing a scan on a tablet", bar: "bg-indigo-500" },
    "Urethral Reconstruction": { img: px(5452277), alt: "Doctors studying an X-ray film", bar: "bg-cyan-600" },
    "Bladder Procedures": { img: px(7089029), alt: "Ultrasound machine in a clinic room", bar: "bg-blue-500" },
    "Laparoscopic Urology": { img: px(11661513), alt: "Surgeon in operating theatre", bar: "bg-teal-500" },
    "Urological Oncology": { img: px(8016904), alt: "Kidney cancer awareness lettering on blue", bar: "bg-blue-700" },
    "Male Infertility": { img: px(7722791), alt: "Laboratory research with microscope", bar: "bg-emerald-500" },
};

export const ARTICLE_IMG = {
    "Kidney Stones": px(7088491),
    "Urinary Symptoms": px(7089029),
    "Prostate Health": px(8376225),
    "UTI": px(7722791),
    "Men's Health": px(5336957),
    "Urethral Stricture": px(5452277),
    "Urological Cancer": px(8016904),
    "Pediatric Urology": px(8612924),
    "General Urology": px(8533045),
};

export const ARTICLE_SLUG_IMG = {
    "why-do-i-need-to-urinate-frequently": px(8460095),
    "what-causes-urinary-urgency": px(7089029),
    "when-does-a-kidney-stone-need-surgery": px(7088491),
    "rirs-vs-pcnl-understanding-kidney-stone-treatment": px(7108425),
    "what-is-a-urethral-stricture": px(5452277),
    "blood-in-urine-when-should-you-see-a-urologist": px(7722791),
    "understanding-psa-and-prostate-health": px(8376225),
};

export function articleImage(article) {
    if (article.image_url && article.image_url !== IMAGES.education) return article.image_url;
    return ARTICLE_SLUG_IMG[article.slug] || ARTICLE_IMG[article.category] || IMAGES.education;
}

export const DISCLAIMER = "This website provides general educational information and is not a substitute for an individual medical consultation. Diagnosis and treatment should be based on assessment by a qualified healthcare professional.";
